export default __webpack_public_path__ + "static/media/onboard-frame.6995c495.png";